import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FolderSVG = function FolderSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28,7H15.46l-1.7-2.55A1,1,0,0,0,12.93,4H4A2,2,0,0,0,2,6V25a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V9A2,2,0,0,0,28,7Zm-3,6H14.41L13,14.41a2,2,0,0,1-1.41.59H7a1,1,0,0,1,0-2h4.59L13,11.59A2,2,0,0,1,14.41,11H25a1,1,0,0,1,0,2Z"
  }));
};
FolderSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FolderSVG);